const enum SortItemKey {
  Name = 'DocumentName',
  FileName = 'FileName',
  Type = 'DocumentType',
  Date = 'CreatedOn',
  Relevance = 'Relevance',
}

export default SortItemKey;
